(function () {
  function getCartMaxItems() {
    const n = window.theme?.apis?.cart?.maxItems;
    if (typeof n === 'number' && n >= 1) return n;
    return null;
  }

  function getCartMaxItemsMessage() {
    const el = document.querySelector('cart-error');
    const limit = getCartMaxItems();
    return el?.dataset?.cartMaxItemsError || `Possono essere aggiunti solo un massimo di ${limit} prodotti al carrello`;
  }

  function isCartPage() {
    const p = (window.location.pathname || '').replace(/\/$/, '') || '/';
    return p === '/cart' || p.endsWith('/cart');
  }

  function showCartLimitError() {
    if (typeof window.showCartToast === 'function') {
      window.showCartToast(getCartMaxItemsMessage(), 'error', !isCartPage());
    }
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      return res.ok ? await res.json() : null;
    } catch (e) {
      return null;
    }
  }

  function getCartTotalQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce((total, item) => {
      const qty = typeof item.quantity === 'number' ? item.quantity : 0;
      return total + qty;
    }, 0);
  }

  window.cartLimitUtils = {
    getCartMaxItems,
    getCartMaxItemsMessage,
    isCartPage,
    showCartLimitError,
    fetchCart,
    getCartTotalQuantity,
  };
})();
